import {makeStyles} from "tss-react/mui";
import {IModuleScheduled} from "@buildwitt/shapeshift-types";
import {Box, BoxProps, Typography} from "@mui/material";
import {TrainingFeedModule} from "../../components/trainingFeed/TrainingFeedModule";
import {TrainingFeedModuleSkeleton} from "./TrainingFeedModuleSkeleton";
import {TrainingFeedModuleSkeletonSlim} from "./TrainingFeedModuleSkeletonSlim";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import {palette} from "../../constants";
import {TrainingFeedModuleSlim} from "../../components/trainingFeed/trainingFeedModuleSlim";
import {useSSTranslation} from "../../i18n/useSSTranslation";

interface IProps extends BoxProps {
	day: Date //> expects day to have no time
	isLoading?: boolean,
	slim?: boolean,
	data?: IModuleScheduled[],
}

interface IStyleProps {
	slim?: boolean
}

const useStyles = makeStyles<IStyleProps>()((theme, {slim}) => ({
	scheduledDayModules: {
		width: "100%",
		display: "flex",
		gap: "20px",
		flexWrap: "wrap",
		boxSizing: "border-box",
		paddingBottom: 0
	},
	nothingScheduledContainer: {
		minHeight: slim ? "94px": "476px",
		display: "flex",
		flexDirection: slim ? "row" : "column",
		justifyContent: "center",
		padding: slim ? "20px" : "50px",
		textAlign: "center",
		boxSizing: "border-box",
		"svg": {
			margin: "10px auto",
			width: slim ? "40px" : "100px",
			height: slim ? "40px" : "100px",
			"path": {
				fill: palette.greySolid
			}
		},
		"& h5": slim ? {
			padding: "18px",
			fontSize: "15px",
			color: palette.grey70
		} : {}
	}
}));

export const ScheduledDayModules: React.FC<IProps> = ({day, slim, isLoading, className, data, ...props}) => {
	day.setHours(0,0,0,0)
	const startDate = day;
	const endDate = new Date(day);
	endDate.setDate(endDate.getDate() + 1);
	const {classes, cx} = useStyles({slim});
	const {t} = useSSTranslation();


	return (
		<Box
			className={cx(classes.scheduledDayModules, className)}
			data-test-id="training-feed-scheduled-modules"
			role="list"
			aria-label={isLoading ? "Loading modules" : data?.length === 0 ? "No modules scheduled" : `${data?.length} scheduled modules`}
			{...props}
		>
			{(isLoading)
				? (slim ? [1] : [1]).map(e => (slim
					? <TrainingFeedModuleSkeletonSlim key={e} />
					: <TrainingFeedModuleSkeleton key={e} />))
				: data?.map(module => slim
					? <TrainingFeedModuleSlim
						key={module.course.slug + "_" + module.type + "_" + module.id}
						module={module}
					/>
					:<TrainingFeedModule
						key={module.course.slug + "_" + module.type + "_" + module.id}
						module={module}
					/>
				)}
			{!(isLoading) && data?.length === 0 &&
				<Box
					className={classes.nothingScheduledContainer}
					data-test-id="training-feed-nothing-scheduled"
					role="status"
					aria-label="No training modules scheduled for this day"
				>
					<EventBusyIcon aria-hidden="true" />
					<Typography
						variant="h5"
						data-test-id="training-feed-nothing-scheduled-text"
					>
						{t("training_feed_nothing_scheduled", "Nothing scheduled")}
					</Typography>
				</Box>
			}
		</Box>
	)
}